(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('ImportationDialogController', ImportationDialogController);

    ImportationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Importation'];

    function ImportationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Importation) {
        var vm = this;

        vm.importation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.importation.id !== null) {
                Importation.update(vm.importation, onSaveSuccess, onSaveError);
            } else {
                Importation.save(vm.importation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('josdaviApp:importationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateDerniereExecution = false;

        vm.setFichier = function ($file, importation) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        importation.fichier = base64Data;
                        importation.fichierContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
